const SEO = [
	{
		page: "home",
		description:
			"I am fullstack developer having skill on MERN stack.",
		keywords: ["Prajwal", "Prajwal", "Prajwal Shrestha"],
	},

	{
		page: "about",
		description:
			"I am fullstack developer having skill on MERN stack.",
		keywords: ["Prajwal", "Prajwal", "Prajwal Shrestha"],
	},

	{
		page: "projects",
		description:
			"",
		keywords: ["Prajwal", "Prajwal", "Prajwal Shrestha"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Prajwal", "Prajwal N", "Prajwal Shrestha"],
	},
];

export default SEO;
